<div class="container-html wrapper">
  <app-header-navbar
    [isAdmin]="isAdmin"
  ></app-header-navbar>
  <div class="container mt-3 page-body">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
